import React from "react";
import { MdEdit } from "react-icons/md";
import { HiDuplicate } from "react-icons/hi";

import { AiFillEye } from "react-icons/ai";

interface TanTableActionsProps {
  rowOriginal: any;
  onEdit?: (row: any) => void;
  onPreview?: (row: any) => void;
  onDelete?: (row: any) => void;
  onDuplicate?: (row: any) => void;
}

export const TanTableActions = ({
  onEdit,
  onDelete,
  onDuplicate,
  onPreview,
  rowOriginal,
}: TanTableActionsProps) => {
  return (
    <>
      {[onEdit, onDelete].filter(Boolean).length > 0 && (
        <td className="pr-2 align-middle">
          <span className="flex gap-2 justify-end">
            {onDelete && (
              <TanTableDeleteIcon onClick={() => onDelete(rowOriginal)} />
            )}
            {onEdit && (
              <MdEdit
                onClick={(e) => {
                  e.stopPropagation();
                  onEdit(rowOriginal);
                }}
                size={24}
                className="whitespace-nowrap text-right cursor-pointer hover:text-blue-500"
              />
            )}
            {onDuplicate && (
              <HiDuplicate
                size={24}
                onClick={(e) => {
                  e.stopPropagation();
                  onDuplicate(rowOriginal);
                }}
                className="whitespace-nowrap text-right cursor-pointer hover:text-blue-500"
              />
            )}
            {onPreview && (
              <AiFillEye
                size={24}
                onClick={(e) => {
                  e.stopPropagation();
                  onPreview(rowOriginal);
                }}
                className="whitespace-nowrap text-right cursor-pointer hover:text-blue-500"
              />
            )}
          </span>
        </td>
      )}
    </>
  );
};

interface TanTableDeleteIconProps {
  onClick: () => void;
}

const TanTableDeleteIcon = ({ onClick }: TanTableDeleteIconProps) => {
  return (
    <button
      className="text-rose-500 hover:text-rose-600 rounded-full"
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
        <g id="_01_align_center" data-name="01 align center">
          <path d="M22,4H17V2a2,2,0,0,0-2-2H9A2,2,0,0,0,7,2V4H2V6H4V21a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V6h2ZM9,2h6V4H9Zm9,19a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V6H18Z" />
          <rect x="9" y="10" width="2" height="8" />
          <rect x="13" y="10" width="2" height="8" />
        </g>
      </svg>
    </button>
  );
};
